import PropTypes from 'prop-types';
import SwiperImpl from './swiper.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Swiper component.
 *
 * @class Swiper
 * @memberof Mojito.Presentation.Components
 */

/**
 * Swiper prop types.
 *
 * @property {node} [children] - Children react elements. Content to slide.
 * @property {boolean} [hideNavigationArrows] - A flag indicating whether carousel navigation arrows should be displayed or not.
 * @property {boolean} [forceNavigationArrows] - Takes over the internal hover detection of the navigation arrows. Can be used to show the arrows while another element is hovered.
 * @property {Function} [onSlideChange = noop] - Callback triggered when swiper slide changed.
 * @property {Function} [onPrepareSlidesToRender = noop] - Callback triggered when swiper slides are prepared to render.
 * Accepts an array with a list of slide indexes that are visible or going to be visible soon after swipe left or right.
 * @property {Function} [elementRef] - A ref to the rendered element.
 * @property {string} [scrollResetHash] - Hash of the slides. Each time it changes the swiper scrolls back to the first slide, for example when the slides are replaced by another list.
 *
 * @memberof Mojito.Presentation.Components.Swiper
 */
const propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.arrayOf(PropTypes.func),
        PropTypes.node,
    ]),
    hideNavigationArrows: PropTypes.bool,
    forceNavigationArrows: PropTypes.bool,
    onSlideChange: PropTypes.func,
    onPrepareSlidesToRender: PropTypes.func,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    scrollResetHash: PropTypes.string,
};

const defaultProps = {
    hideNavigationArrows: false,
    onSlideChange: noop,
    onPrepareSlidesToRender: noop,
};

export default UIView('Swiper', SwiperImpl, propTypes, defaultProps);
